import React from 'react'
import { useIntl } from 'react-intl'
import { css, cx } from '@emotion/css'
import { badgeCss } from '../../legacy-design-system/text'
import { Dropdown } from '../../legacy-design-system/dropdown'
import { theme } from '@contrast-security-inc/design-system-foundations'
import {
  ProtectMode,
  protectModeI18nConfig,
  protectModeShortcutI18nConfig
} from './protect-mode'
import { ProtectModeBadge } from './protect-mode-badge'

export const dropdownSelectedItemTestId = 'protect-mode-dropdown-selected-item'

interface Props {
  readonly modes: ProtectMode[]
  readonly selectedMode: ProtectMode
  readonly onChange: (mode: ProtectMode) => void
}

export function ProtectModeDropdown({ modes, selectedMode, onChange }: Props) {
  const { formatMessage } = useIntl()

  return (
    <Dropdown<ProtectMode>
      menuE2eTestId="protect-mode-dropdown-menu"
      onChange={onChange}
      items={modes}
      selectedItem={selectedMode}
      itemToString={(mode) =>
        formatMessage({ id: protectModeShortcutI18nConfig[mode] })
      }
      selectionToggleRenderer={({ getToggleButtonProps, isOpen }) => {
        return (
          <div
            {...getToggleButtonProps()}
            data-testid={dropdownSelectedItemTestId}
          >
            <ProtectModeBadge mode={selectedMode} isExpanded={isOpen} />
          </div>
        )
      }}
      menuItemRenderer={({ item }) => {
        const itemLabel = formatMessage({
          id: protectModeI18nConfig[item]
        })

        return (
          <div>
            <div
              data-testid="protect-mode-dropdown-menu-item"
              className={cx(
                badgeCss,
                css`
                  color: ${theme.color.neutral90};
                `
              )}
            >
              {itemLabel}
            </div>
          </div>
        )
      }}
      styleOverrides={{
        outerContainerCss: css`
          width: initial;
        `,
        menuCss: css`
          min-width: 100px;
          width: auto;
        `
      }}
    />
  )
}
